import axiosConfig from "../../ApiCall/axiosConfig";
import { useTranslation } from "react-i18next";

import {
  Container,
  Item,
  Card,
  Title,
  DivItems,
  Img,
  DiscountPrice,
  DivDiscountPrice,
  Price,
  DivImg,
  Btn,
  Icon,
  DivDetails,
  Description,
  DivDiscount,
  DivQuantity,
  Quantity,
  MeasureUnit,
  DivPrice,
  DivShowShoppingCart,
  ContainerShowShoppingCart,
  ButtonShowShoppingCart,
  SumPrice,
  UnitSumPrice,
  Company,
  CompanyDefualtIcon,
  TextNoItems,
  RaedyCart,
  ImgReadyCart,
  DivRaedyCarts,
  ButtonAddRaedyCart,
  ImgButton,
  DivInput,
  Input,
  CustomSheet,
  BtnBottomSheet,
  DivBtnBottomSheet,
  SpanContent,
} from "./Element";
import card from "../../Images/cards/shoppingCart.svg";
import addIcon from "../../Images/add.svg";
import minusIcon from "../../Images/minus.svg";
import deleteIcon from "../../Images/delete.svg";
import addReadyCartIcon from "../../Images/cartPage/productAddToReadyCart.svg";
import bottomSheateReadyCartIcon from "../../Images/cartPage/bottomSheateReadyCart.svg";
import defualtCompanyIcon from "../../Images/defaultImage/deliveryCompany.svg";
import { Sheet } from "react-modal-sheet";
import { useEffect, useState } from "react";
const customTheme = "red";
const Body = ({
  data,
  readyCartData,
  updateData,
  showError,
  updateItems,
  detailReadyCart,
}) => {
  const [title, setTitle] = useState("");
  const [items, setItems] = useState([]);
  const [item, setItem] = useState(null);
  const [detailItem, setDetailItem] = useState([]);

  const [readyCartItems, setReadyCartItems] = useState([]);
  const [isOpen, setOpen] = useState(false);
  const [isOpenSingle, setOpenSingle] = useState(false);
  const [showDeleteProductSheet, setShowDeleteProductSheet] = useState(false);
  const { t } = useTranslation();
  const handleChange = (e) => {
    setTitle(e.currentTarget.value);
  };

  useEffect(() => {
    setItems(data);
    setItem(detailReadyCart);
    setReadyCartItems(readyCartData);
  }, [data, readyCartData, detailReadyCart]);
  const numberWithCommas = (x) => {
    return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const handleAddReadyCartToShoppingCart = async () => {
    let itemsArray = [];
    setOpen(false);
    let isOkResponse;
    const token = localStorage.getItem("tokenManiarApp");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
      },
    };
    try {
      items?.items.forEach((item) => {
        itemsArray.push({
          company_id: item?.company?.id,
          product_id: item?.product?.id,
          quantity: item?.quantity,
        });
      });
      await axiosConfig.post("/shopping_cart/item/store", itemsArray, config);
      isOkResponse = true;
    } catch (error) {
      isOkResponse = false;
      console.log("Error response from server:", error);
    }
    if (isOkResponse) {
      updateData("addShoppingCartToReadyCart");
    } else {
      showError();
    }
  };
  const handleAddProductToShoppingCart = async () => {
    setOpen(false);
    let isOkResponse;
    const token = localStorage.getItem("tokenManiarApp");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
      },
    };
    try {
      await axiosConfig.post(
        "/shopping_cart/item/store",
        [
          {
            company_id: detailItem?.company?.id,
            product_id: detailItem?.product?.id,
            quantity: detailItem?.quantity,
          },
        ],
        config
      );
      isOkResponse = true;
    } catch (error) {
      isOkResponse = false;
    }
    if (isOkResponse) {
      setOpenSingle(false);
      updateData("addProductToReadyCart");
    } else {
      setOpenSingle(false);
      showError();
    }
  };

  const handleOperation = async (itemDetail, operation, type) => {
    let isOkResponse;
    const token = localStorage.getItem("tokenManiarApp");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
      },
    };
    if (type === "update") {
      let quantity;
      if (operation === "add") {
        quantity = itemDetail?.quantity + 1;
      } else {
        quantity = itemDetail?.quantity - 1;
      }
      try {
        await axiosConfig.put(
          "/ready_cart/item/update/" + itemDetail?.id,
          {
            quantity: quantity,
          },
          config
        );
        isOkResponse = true;
      } catch (error) {
        isOkResponse = false;
        console.log("Error response from server:", error);
        showError();
      }
    } else if (type === "delete") {
      try {
        await axiosConfig.delete(
          "/ready_cart/item/delete/" + itemDetail?.id,
          config
        );
        isOkResponse = true;
      } catch (error) {
        isOkResponse = false;
        console.log("Error response from server:", error);
        showError();
      }
    }

    if (isOkResponse) {
      updateItems();
    }
  };
  return (
    <>
      {items.items?.length === 0 ? (
        <TextNoItems>
          <p>محصولی در سبد آماده شما وجود ندارد</p>
        </TextNoItems>
      ) : (
        <Container>
          <CustomSheet
            isOpen={isOpen}
            onClose={() => setOpen(false)}
            detent="content-height"
            className={customTheme}
          >
            <Sheet.Container>
              <Sheet.Content>
                <p>
                  آیا <SpanContent type="add">{item?.title}</SpanContent> به سبد
                  خریدتان اضافه شود؟
                </p>
                <Sheet.Scroller>
                  <DivBtnBottomSheet>
                    <BtnBottomSheet
                      type="cancel"
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      خیر
                    </BtnBottomSheet>
                    <BtnBottomSheet
                      type="ok"
                      onClick={() => {
                        handleAddReadyCartToShoppingCart();
                      }}
                    >
                      بله
                    </BtnBottomSheet>
                  </DivBtnBottomSheet>
                </Sheet.Scroller>
              </Sheet.Content>
            </Sheet.Container>
            <Sheet.Backdrop onClick={() => setOpen(false)} />
          </CustomSheet>
          <CustomSheet
            isOpen={isOpenSingle}
            onClose={() => setOpenSingle(false)}
            detent="content-height"
            className={customTheme}
          >
            <Sheet.Container>
              <Sheet.Content>
                <p>آیا مایل هستید که این محصول به سبد خریدتان اضافه شود؟</p>
                <Sheet.Scroller>
                  <DivBtnBottomSheet>
                    <BtnBottomSheet
                      type="cancel"
                      onClick={() => {
                        setOpenSingle(false);
                      }}
                    >
                      خیر
                    </BtnBottomSheet>
                    <BtnBottomSheet
                      type="ok"
                      onClick={() => {
                        handleAddProductToShoppingCart();
                      }}
                    >
                      بله
                    </BtnBottomSheet>
                  </DivBtnBottomSheet>
                </Sheet.Scroller>
              </Sheet.Content>
            </Sheet.Container>
            <Sheet.Backdrop onClick={() => setOpenSingle(false)} />
          </CustomSheet>
          <CustomSheet
            isOpen={showDeleteProductSheet}
            onClose={() => setShowDeleteProductSheet(false)}
            detent="content-height"
            className={customTheme}
          >
            <Sheet.Container>
              <Sheet.Content>
                <p>آیا مایل هستید که محصول از سبد آماده حذف شود؟</p>

                <Sheet.Scroller>
                  <DivBtnBottomSheet>
                    <BtnBottomSheet
                      type="cancel"
                      onClick={() => {
                        setShowDeleteProductSheet(false);
                      }}
                    >
                      خیر
                    </BtnBottomSheet>
                    <BtnBottomSheet
                      type="ok"
                      onClick={() => {
                        handleOperation(detailItem, "delete", "delete");
                        setShowDeleteProductSheet(false);
                      }}
                    >
                      بله
                    </BtnBottomSheet>
                  </DivBtnBottomSheet>
                </Sheet.Scroller>
              </Sheet.Content>
            </Sheet.Container>
            <Sheet.Backdrop onClick={() => setShowDeleteProductSheet(false)} />
          </CustomSheet>

          <DivItems showShoppingCart={items?.items?.length !== 0}>
            {items?.items?.map((item, index) => (
              <Item key={index}>
                <Card src={card} />
                <Btn
                  type="addReadyCart"
                  onClick={() => {
                    setOpenSingle(true);
                    setDetailItem(item);
                  }}
                >
                  <Icon src={addReadyCartIcon} />
                </Btn>

                <DivImg>
                  <Img src={item?.product?.image} />
                  {item?.detail?.confirmed_price !==
                    item?.detail?.discount_price &&
                    item?.detail?.discount_type === "percentage" && (
                      <DivDiscount>
                        {item?.detail?.discount_value + "%"}
                      </DivDiscount>
                    )}
                  {item?.detail?.confirmed_price !==
                    item?.detail?.discount_price &&
                    item?.detail?.discount_type === "fixed" && (
                      <DivDiscount>
                        {numberWithCommas(item?.detail?.discount_value) + "-"}
                      </DivDiscount>
                    )}
                </DivImg>
                <DivDetails>
                  <Title>{item?.product?.title}</Title>
                  <Company>
                    {item?.company?.logo ? (
                      <img src={item?.company?.logo} alt="companyLogo" />
                    ) : (
                      <CompanyDefualtIcon src={defualtCompanyIcon} />
                    )}
                    {item?.company?.title}
                  </Company>
                  <Description>{item?.detail_description}</Description>
                </DivDetails>
                {item?.detail ? (
                  <DivPrice>
                    <DivDiscountPrice>
                      قیمت واحد :
                      <DiscountPrice type="unit">
                        {item?.detail?.confirmed_price !==
                          item?.detail?.discount_price &&
                          (item?.detail?.discount_type === "percentage" ||
                            item?.detail?.discount_type === "fixed") && (
                            <Price>
                              {numberWithCommas(item?.detail?.confirmed_price)}
                            </Price>
                          )}
                        {numberWithCommas(item?.detail?.discount_price)}
                      </DiscountPrice>
                      تومان
                    </DivDiscountPrice>
                    <DivDiscountPrice>
                      قیمت کل :
                      <DiscountPrice>
                        {numberWithCommas(item?.sum_price)}
                      </DiscountPrice>
                      تومان
                    </DivDiscountPrice>
                  </DivPrice>
                ) : (
                  <DiscountPrice>ناموجود</DiscountPrice>
                )}
                <Btn
                  type="deleteProduct"
                  onClick={() => {
                    setDetailItem(item);
                    setShowDeleteProductSheet(true);
                  }}
                >
                  <Icon type="delete" src={deleteIcon} />
                </Btn>

                <Btn
                  type="add"
                  onClick={() => handleOperation(item, "add", "update")}
                >
                  <Icon src={addIcon} />
                </Btn>
                <DivQuantity>
                  <Quantity>{item?.quantity}</Quantity>
                  <MeasureUnit>{item?.product?.measure_unit}</MeasureUnit>
                </DivQuantity>
                {item?.quantity !== 1 ? (
                  <Btn onClick={() => handleOperation(item, "minus", "update")}>
                    <Icon type="mines" src={minusIcon} />
                  </Btn>
                ) : (
                  <Btn
                    onClick={() => handleOperation(item, "delete", "delete")}
                  >
                    <Icon type="delete" src={deleteIcon} />
                  </Btn>
                )}
              </Item>
            ))}
          </DivItems>
          <ContainerShowShoppingCart show={items?.items?.length !== 0}>
            <DivShowShoppingCart>
              <ButtonShowShoppingCart onClick={() => setOpen(true)}>
                اضافه کردن به سبد خرید
              </ButtonShowShoppingCart>
              <SumPrice>
                {numberWithCommas(items?.sum_price)}
                <UnitSumPrice>تومان</UnitSumPrice>
              </SumPrice>
            </DivShowShoppingCart>
          </ContainerShowShoppingCart>
        </Container>
      )}
    </>
  );
};

export default Body;
